import { PHONE_STATES } from "@/constants/phone";

const ACTIVE_CALL_STATUSES = [
  PHONE_STATES.RINGING,
  PHONE_STATES.DIALING,
  PHONE_STATES.CONVERSATION,
  PHONE_STATES.HANDING,
];

const createInitialState = () => ({
  status: null,
  isRegistered: false,
  isIncomingCall: false,
  hasSession: false,
});

export default {
  state: createInitialState(),
  getters: {
    getPhoneState: (state) => state,
    getPhoneStatus: (state) => state.status,
    getPhoneIsRegistered: (state) => state.isRegistered,
    getPhoneIsIncomingCall: (state) => state.isIncomingCall,
    getPhoneHasSession: (state) => state.hasSession,
    getPhoneHasActiveCall: (state) => ACTIVE_CALL_STATUSES.includes(state.status),
  },
  mutations: {
    SET_PHONE_STATE_DATA(state, payload) {
      state.status = typeof payload.status === "undefined" ? state.status : payload.status;
      state.isRegistered = typeof payload.isRegistered === "undefined"
        ? state.isRegistered
        : payload.isRegistered;
      state.isIncomingCall = typeof payload.isIncomingCall === "undefined"
        ? state.isIncomingCall
        : payload.isIncomingCall;
      state.hasSession = typeof payload.hasSession === "undefined"
        ? state.hasSession
        : payload.hasSession;
    },
    RESET_PHONE_STATE_DATA(state) {
      Object.assign(state, createInitialState());
    },
  },
};
